import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AudioProvider } from "./context/AudioContext";
import Layout from "./components/Layout";
import Landing from "./components/Landing";
import Works from "./components/Works";
import About from "./components/About";
import Contact from "./components/Contact";
import WorkDetail from "./pages/WorkDetail";
import LearningMusic from "./pages/LearningMusic";
import EquityResearch from "./pages/EquityResearch";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <AudioProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Landing />} />
            <Route path="works" element={<Works />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="work/:slug" element={<WorkDetail />} />
            <Route path="LearningMusic" element={<LearningMusic />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="equity-research" element={<EquityResearch />} />
        </Routes>
      </BrowserRouter>
    </AudioProvider>
  );
}
